import { render, staticRenderFns } from "./HeaderBoxInfo.vue?vue&type=template&id=51756568&scoped=true&"
import script from "./HeaderBoxInfo.vue?vue&type=script&lang=js&"
export * from "./HeaderBoxInfo.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBoxInfo.vue?vue&type=style&index=0&id=51756568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51756568",
  null
  
)

export default component.exports